<template>
  <RydSelect :id="props.id"
             isSearchable
             :defaultValue="props.defaultValue"
             :name="props.name" :label="props.label"
             :placeholder="props.placeholder"
             :idValue="props.idValue"
             :options="filteredOptions"
             :displayValue="props.displayValue"
             :disabled="props.disabled"
             :a11yName="props.a11yName"
             @update="emits('itemSelected', $event)"
  >
    <div class="relative w-full">
      <input v-model="search" 
             :placeholder="props.placeholderSearch" 
             type="text"
             class="rp-fs-16-ls block w-full
            p-3 mt-4 pl-10
            border border-ryd-gray3 rounded-s
            focus:border-ryd-gray5 focus:outline-none focus:ring-1 focus:ring-ryd-gray5"
             autocomplete="off"
             inputmode="search"
             @input="search = ($event.target as HTMLInputElement).value"
      />
      <RydIcon icon="symbols/search" class="absolute top-4 left-3 text-ryd-gray4" />
    </div>
  </RydSelect>
</template>
<script setup lang="ts">
import { computed, ref, PropType, ComputedRef } from 'vue';
import RydSelect from '@/components/RydSelect/RydSelect.vue';
import RydIcon from '@/components/RydIcon/RydIcon.vue';

type RydSelectOption = {
  id: string;
  [key: string]: string | number;
};

const props = defineProps({
  id: {
    type: String,
    default: () => '',
  },
  defaultValue: {
    type: [Object, String, Number] as PropType<RydSelectOption | string | number>,
    default: null,
  },
  options: {
    type: Array as PropType<RydSelectOption[]>,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false
  },
  displayValue: {
    type: [String, Boolean, Number],
    default: false,
  },
  name: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  a11yName: {
    type: String,
    default: ''
  },
  idValue: {
    type: [String, Number],
    default: null,
  },
  placeholder: {
    type: String,
    default: ''
  },
  placeholderSearch: {
    type: String,
    default: 'Search brands...'
  }

});
const emits = defineEmits(['itemSelected']);

const search = defineModel({
  type: String,
  default: ''
});
const filteredOptions: ComputedRef<RydSelectOption[] | []> = computed(() => {
  if (!props.options) return [];
  return props.options.filter(item => {

    const value = item[props.displayValue as string];
    const res = typeof value === 'string' && value.toLowerCase().startsWith(search.value.toLowerCase());
    return res;

  }
  );
});
</script>